module.exports = __webpack_public_path__ + "img/gy_img8.18a6f6a3.png";